<template>
  <div v-show="editShow">
    <div class="container">
      <el-row :gutter="20">
        <div class="clearfix">
          <div class="crumbs">
            <i class="el-icon-back"></i>
            <el-button type="text" @click="goBack">返回</el-button>
          </div>
          <div class="btn-save">
            <el-button type="primary" @click="saveClick('formData')"
            >保存
            </el-button
            >
          </div>
        </div>
        <div class="form-box">
          <el-form
              :model="formData"
              :rules="rules"
              ref="formData"
              label-width="120px"
              class="eidt-el-form"
          >
            <el-form-item label="项目类型" prop="projectTypeId">
              <el-select
                  v-model="formData.projectTypeId"
                  placeholder="请选择项目类型"
              >
                <el-option
                    v-for="(type, index) in productType"
                    :label="type.name"
                    :key="index"
                    :value="type.projectTypeId"
                >
                  <div @click="getChangeType(type)">{{ type.name }}</div>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="项目经理" prop="accountId">
              <el-select
                  v-model="formData.accountId"
                  placeholder="项目角色"
                  :filterable="true"
              >
                <el-option
                    v-for="(item, index) in users"
                    :label="item.name"
                    :key="index"
                    :value="item.accountId"
                >
                  <div @click="getChange(item)">{{ item.name }}</div>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="项目名称" prop="name">
              <el-input v-model="formData.name"></el-input>
            </el-form-item>
            <el-form-item label="项目地址" prop="address">
              <el-input v-model="formData.address"></el-input>
            </el-form-item>
            <UploadImg
                @uploadImg="getUploadImg"
                :editImg="editImg"
                :imgTitle="imgTitle"
            ></UploadImg>
            <UploadImg
                @uploadImg="getUploadImg1"
                :editImg="editImg1"
                :imgTitle="imgTitle1"
            ></UploadImg>
            <el-form-item label="查票页面宽度" prop="total">
              <el-input
                  v-model="formData.total"
                  type="number"
                  :min="0"
              ></el-input>
            </el-form-item>
            <el-form-item label="查票页面顶部距离" prop="sms">
              <el-input
                  v-model="formData.sms"
                  type="number"
                  :min="0"
              ></el-input>
            </el-form-item>
            <el-form-item label="开始时间" prop="startDate">
              <el-date-picker
                  value-format="yyyy-MM-dd HH:mm:ss"
                  v-model="formData.startDate"
                  type="datetime"
                  placeholder="开始日期"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="结束时间" prop="endDate">
              <el-date-picker
                  value-format="yyyy-MM-dd HH:mm:ss"
                  v-model="formData.endDate"
                  type="datetime"
                  placeholder="结束日期"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="入场限制开始" prop="inStartDate">
              <el-date-picker
                  value-format="yyyy-MM-dd HH:mm:ss"
                  v-model="formData.inStartDate"
                  type="datetime"
                  placeholder="入场限制开始日期"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="入场限制结束" prop="inEndDate">
              <el-date-picker
                  value-format="yyyy-MM-dd HH:mm:ss"
                  v-model="formData.inEndDate"
                  type="datetime"
                  placeholder="入场限制结束日期"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="入场限制时间" prop="inTime">
              <el-input-number :min="0" :max="1000" :precision="0" v-model="formData.inTime">
                <template slot="suffix">秒</template>
              </el-input-number>
            </el-form-item>
            <el-form-item label="回调地址" prop="callbackUrl">
              <el-input v-model="formData.callbackUrl"></el-input>
            </el-form-item>
            <el-form-item label="回调错误邮箱" prop="email">
              <el-input v-model="formData.email"></el-input>
            </el-form-item>
            <el-form-item label="短信签名" prop="signName">
              <el-input v-model="formData.signName"></el-input>
            </el-form-item>
            <el-form-item label="短信平台" prop="label">
              <el-radio-group v-model="formData.label" @change="getRadioSms">
                <el-radio :label="0">腾讯</el-radio>
                <el-radio :label="1">赛邮</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="短信平台" prop="label">
              <el-select v-model="formData.label">
                <el-option :value="1" label="赛邮"></el-option>
                <el-option :value="0" label="腾讯"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="是否启用">
              <el-radio-group v-model="formData.enabled" @change="getRadio">
                <el-radio :label="0">禁用</el-radio>
                <el-radio :label="1">启用</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="同步时间" prop="syncDate">
              <el-date-picker
                  v-model="formData.syncDate"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetime"
                  placeholder="同步时间"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="第三方项目ID" prop="mettingId">
              <el-input v-model="formData.mettingId"></el-input>
            </el-form-item>
            <el-form-item label="出口人数" prop="exportQty">
              <el-input-number v-model="formData.exportQty"></el-input-number>
            </el-form-item>
            <el-form-item label="馆内人数校正" prop="exportCorrectionQty">
              <el-input-number v-model="formData.exportCorrectionQty"></el-input-number>
            </el-form-item>
            <el-form-item label="taskId" prop="taskId">
              <el-input v-model="formData.taskId"></el-input>
            </el-form-item>
            <el-form-item label="orgId" prop="orgId">
              <el-input v-model="formData.orgId"></el-input>
            </el-form-item>
            <el-form-item prop="appId" label="appkey">
              <el-input
                  v-model="formData.appId"
                  placeholder="微信AppId"
              ></el-input>
            </el-form-item>
            <el-form-item prop="appSecret" label="密钥">
              <el-input
                  v-model="formData.appSecret"
                  placeholder="微信公众号秘钥"
              ></el-input>
            </el-form-item>
            <el-form-item label="配置" prop="config">
              <el-input
                  v-model="formData.config"
                  :autosize="{ minRows: 4, maxRows: 1000 }"
                  type="textarea"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
      </el-row>
    </div>
  </div>
</template>

<script>
import UploadBanner from "./uploadImg/UploadBanner";
import UploadImg from "../public/UploadImg";
import bus from "../common/bus";
import checkPhone from "../common/checkPhone";

export default {
  name: "editprojectmanage",
  data() {
    return {
      rules: {
        accountId: [
          {required: true, message: "请选择项目经理", trigger: "blur"},
        ],
        name: [{required: true, message: "请填写名称", trigger: "blur"}],
        address: [{required: true, message: "请填写地点", trigger: "blur"}],
        projectTypeId: [
          {required: true, message: "请选择项目类型", trigger: "blur"},
        ],
        startDate: [
          {required: true, message: "请选择开始时间", trigger: "blur"},
        ],
        endDate: [
          {required: true, message: "请选择结束时间", trigger: "blur"},
        ],
      },
      gb: window.location.hostname.indexOf("gb") > -1,
      formData: {
        exportCorrectionQty: 0,
        exportQty: 0,
        appId: "",
        appSecret: "",
        projectTypeId: "",
        mettingId: "",
        taskId: "",
        orgId: "",
        syncDate: "",
        name: "",
        label: 1,
        address: "",
        phone: "",
        banner: "",
        signName: window.location.hostname.indexOf("gb") > -1 ? "P3H6g" : "",
        total: "",
        sms: "",
        email: "",
        callbackUrl: "",
        startDate: "",
        endDate: "",
        inStartDate: "",
        inEndDate: "",
        inTime: "",
        accountId: "",
        url: "",
        config: "",
        enabled: 0,
      },
      projectTypeId: 0,
      admin: "",
      productType: [],
      users: [],
      editImg: "",
      editImg1: "",
      project_Id: "",
      imgTitle: "查票banner",
      imgTitle1:
          location.href.indexOf("huiyi.59huiyi.com") > 0
              ? "查票图片"
              : "项目logo",
    };
  },
  props: {
    editShow: {
      type: Boolean,
      default: false,
    },
    arrarList: {
      type: Array,
      default() {
        return [];
      },
    },
    editData: {
      type: Object,
    },
  },
  watch: {
    editData: function () {
      const item = this.editData;
      if (item) {
        this.formData = item;
        this.admin = item.admin;
        this.project_Id = item.projectId;
        this.editImg = item.banner;
        this.editImg1 = item.url;
        if (item.label) {
          this.formData.label = parseInt(item.label);
        }
      }
    },
  },
  created() {
    bus.$on("getPTypeId", (message) => {
      this.ProjectTypeId = message;
    });
    this.getProductType();
    this.getUsers();
  },
  methods: {
    check(query) {
      this.$axios
          .post("/Account/Phone/", {pageIndex: 0, pageSize: 10, name: query})
          .then((res) => {
            if (res.data.hasError == false) {
              if (res.data.data) {
                this.users = [{...res.data.data}];
              }
            }
          });
    },
    getUsers() {
      this.$axios.get("/Account/").then((res) => {
        if (res.data.hasError == false) {
          this.users = [...res.data.data];
        }
      });
    },
    getProductType() {
      this.$axios.get("/ProjectType/").then((res) => {
        if (res.data.hasError == false) {
          this.productType = [...res.data.data];
        }
      });
    },
    getRadio(value) {
      this.formData.enabled = value;
    },
    getRadioSms(value) {
      this.formData.label = value;
    },
    getChangeType(type) {
      this.projectTypeId = type.projectTypeId;
    },
    saveClick(formData) {

      this.formData = {
        projectTypeId: this.formData.projectTypeId,
        name: this.formData.name,
        address: this.formData.address,
        phone: this.formData.phone,
        banner: this.editImg,
        signName: this.formData.signName,
        total: this.formData.total,
        sms: this.formData.sms,
        label: this.formData.label,
        email: this.formData.email,
        callbackUrl: this.formData.callbackUrl,
        startDate: this.formData.startDate,
        endDate: this.formData.endDate,
        enabled: this.formData.enabled,
        inEndDate: this.formData.inEndDate,
        inStartDate: this.formData.inStartDate,
        inTime: this.formData.inTime,
        accountId: this.formData.accountId,
        admin: this.admin,
        config: this.formData.config,
        url: this.formData.url,
        appId: this.formData.appId,
        appSecret: this.formData.appSecret,
        mettingId: this.formData.mettingId,
        taskId: this.formData.taskId,
        orgId: this.formData.orgId,
        syncDate: this.formData.syncDate,
        exportQty: this.formData.exportQty,
        exportCorrectionQty: this.formData.exportCorrectionQty,
      };

      this.$refs[formData].validate((valid) => {
        if (valid) {
          if (!this.project_Id) {
            this.$axios.post("/Project/", this.formData).then((res) => {
              if (res.data.hasError == false) {
                this.$message.success("保存成功！");
                this.$refs[formData].resetFields();
                this.goBack();
              } else {

                this.$message.error(res.data.message);
              }
            });
          } else {
            this.$axios
                .put("/Project/" + this.project_Id, this.formData)
                .then((res) => {
                  if (res.data.hasError == false) {
                    this.$message.success("编辑成功！");
                    this.$refs[formData].resetFields();
                    this.goBack();
                  } else {

                    this.$message.error(res.data.message);
                  }
                });
          }
        } else {
          return false;
        }
      });
    },
    getChange(item) {
      this.formData.phone = item.phone;
      this.admin = item.name;
    },
    getUploadImg(imgSrc) {
      this.editImg = imgSrc;
    },
    getUploadImg1(imgSrc) {
      this.formData.url = imgSrc;
    },
    goBack() {
      this.project_Id = "";
      this.admin = "";
      this.editImg = "";
      this.editImg1 = "";
      this.$emit("backFunStu");
      this.$refs["formData"].resetFields();
    },
  },
  components: {
    UploadImg,
  },
};
</script>

<style lang="scss">
.container {
  margin-bottom: 10px;
}

.el-inpt-phone {
  width: calc(100% - 70px);
}

.jc-btn {
  position: absolute;
  width: 60px;
  right: 0;
}
</style>